import { ContentEvent, MAX_CONTENT_EVENTS_PER_REQUEST } from 'apis/CompanyAPI/tracking/types';

const eventKey = (event: ContentEvent) => `${event.contentId}|${event.type}|${event.surface}`;

/**
 * Collects post events and sends them in batches. Each event (post, type and surface) is sent at most once for the
 * lifetime of the queue (i.e. once per page session). Sending is fire-and-forget: failures are swallowed and not retried.
 */
export function createContentEventQueue(send: (events: ContentEvent[]) => Promise<unknown>) {
  const seen = new Set<string>();
  let pending: ContentEvent[] = [];

  return {
    add(event: ContentEvent) {
      const key = eventKey(event);
      if (seen.has(key)) return;
      seen.add(key);
      pending.push(event);
    },
    hasPending() {
      return pending.length > 0;
    },
    flush() {
      const events = pending;
      pending = [];
      for (let i = 0; i < events.length; i += MAX_CONTENT_EVENTS_PER_REQUEST) {
        send(events.slice(i, i + MAX_CONTENT_EVENTS_PER_REQUEST)).catch(() => {});
      }
    },
  };
}
